// extracted by mini-css-extract-plugin
export default {"root_blockBtn":"OrderActionBtn_root_blockBtn__2QWAK","btnBlock":"OrderActionBtn_btnBlock__yU9Fg"};